import { FaBars, FaUser, FaCog, FaSignOutAlt, FaBell } from "react-icons/fa"; // FaBell add kiya
import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { onErrorLogout } from "../_config/authService";
import profile from "../assets/img/profile.jpg";
import { makeRequestAuth } from "../_config/api";
import { showErrorToast } from "../utils/toastUtils";

function Header({ onToggleSidebar, sidebarOpen }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [notifOpen, setNotifOpen] = useState(false); // Notification state
  const menuRef = useRef(null);
  const notifRef = useRef(null); // Notif ref for outside click
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);
  const [profiles, setProfile] = useState(null);


    const [notifications, setNotifications] = useState([]);
    const lastSeen = localStorage.getItem("admin_last_seen_notif");
    const unreadCount = notifications.filter((n) => {
      if (n.isRead) return false;
      if (lastSeen && new Date(n.createdAt) <= new Date(lastSeen)) return false;
      return true;
    }).length;

  const fetchNotifications = async () => {
    try {
      const res = await makeRequestAuth("post", "/admin/getAdminNotifications");
      if (res?.error === false) {
        setNotifications(res.data || []);
      }
    } catch (error) {
      console.error("Failed to fetch notifications");
    }
  };

  const handleToggleNotif = async () => {
    const nextState = !notifOpen;
    setNotifOpen(nextState);
    setMenuOpen(false);

    if (nextState) {
      localStorage.setItem("admin_last_seen_notif", new Date().toISOString());
      setNotifications((prev) => prev.map((n) => ({ ...n, isRead: true })));
      try {
        await makeRequestAuth("post", "/admin/markAdminNotificationsRead");
      } catch (err) {
        console.error("Failed to mark notifications read:", err);
      }
    }
  };

  const handleViewAll = async () => {
    setNotifOpen(false);
    localStorage.setItem("admin_last_seen_notif", new Date().toISOString());
    setNotifications((prev) => prev.map((n) => ({ ...n, isRead: true })));
    try {
      await makeRequestAuth("post", "/admin/markAdminNotificationsRead");
    } catch (err) {
      console.error("Failed to mark notifications read:", err);
    }
  };

  useEffect(() => {
    fetchNotifications();
    // 30 seconds me auto-refresh karne ke liye
    const interval = setInterval(fetchNotifications, 30000);
    return () => clearInterval(interval);
  }, []);

  // Dummy notifications - aap isse API se fetch kar sakte hain
  // const notifications = [
  //   { id: 1, title: "New Loan Query", time: "5 min ago", read: false },
  //   { id: 2, title: "Profile Updated", time: "1 hour ago", read: true },
  // ];

  const fetchProfile = async () => {
    try {
      const res = await makeRequestAuth("post", "/admin/adminprofile");
      if (res?.error === false) {
        setProfile(res.data);
      } else {
        showErrorToast(res?.message || "Unable to load profile!");
      }
    } catch (error) {
      showErrorToast(error?.message || "Server error!");
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
      if (notifRef.current && !notifRef.current.contains(event.target)) {
        setNotifOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header
      className={`bg-white dark:bg-[#071225] text-gray-900 dark:text-white fixed top-0 right-0 z-20 flex items-center justify-between 
    px-4 sm:px-6 py-3 shadow-sm transition-all duration-700 ease-in-out w-full
    ${sidebarOpen ? "lg:ml-64 lg:w-[calc(100%-16rem)]" : "lg:ml-0 lg:w-full"}`}
    >
      {/* Left */}
      <div className="flex items-center space-x-3">
        <button
          onClick={onToggleSidebar}
          className="p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none"
        >
          <FaBars size={20} />
        </button>

        <h1 className="hidden sm:block text-lg sm:text-2xl font-bold text-gray-900 dark:text-white">
          Welcome, Admin
        </h1>
      </div>

      {/* Right */}
      <div className="flex items-center space-x-4 sm:space-x-6">

        {/* --- NOTIFICATION BELL START --- */}
        <div className="relative" ref={notifRef}>
          <button
            onClick={handleToggleNotif}
            className="relative p-2 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors"
          >
            <FaBell size={20} />
            {/* Red Badge for unread count */}
            {unreadCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-bold h-[18px] min-w-[18px] px-1 rounded-full flex items-center justify-center border-2 border-white dark:border-[#071225] shadow-sm leading-none">
                {unreadCount > 99 ? "99+" : unreadCount}
              </span>
            )}
          </button>

          {notifOpen && (
            <div className="absolute right-0 mt-3 w-72 bg-white dark:bg-[#1E2335] rounded-2xl shadow-xl border border-gray-100 dark:border-white/10 z-50 overflow-hidden animate-dropdown">
              <div className="px-4 py-3 border-b border-gray-100 dark:border-white/10 flex justify-between items-center">
                <span className="font-bold text-sm">Notifications</span>
                <span className="text-[10px] bg-blue-100 text-blue-600 font-semibold px-2 py-0.5 rounded-full">
                  {unreadCount > 0 ? `${unreadCount} New` : "0 New"}
                </span>
              </div>
              <div className="max-h-60 overflow-y-auto">
                {notifications.length === 0 ? (
                  <p className="text-xs text-gray-400 text-center py-6">No notifications</p>
                ) : (
                  notifications.map((n) => (
                    <div key={n._id} className="px-4 py-3 hover:bg-gray-50 dark:hover:bg-white/5 cursor-pointer border-b border-gray-50 dark:border-white/5 last:border-0">
                      <p className="text-sm font-medium dark:text-gray-200">{n.title}</p>
                      <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                        {new Date(n.createdAt).toLocaleString()}
                      </p>
                    </div>
                  ))
                )}
              </div>
              <div className="px-4 py-2 text-center border-t border-gray-100 dark:border-white/10">
                <Link to="/notifications" onClick={handleViewAll} className="text-xs text-blue-500 font-semibold hover:underline">View All</Link>
              </div>
            </div>
          )}
        </div>
        {/* --- NOTIFICATION BELL END --- */}

        {/* Profile Menu */}
        <div className="relative" ref={menuRef}>
          <div
            onClick={() => { setMenuOpen(!menuOpen); setNotifOpen(false); }}
            className="flex items-center space-x-2 cursor-pointer 
             sm:hover:bg-gray-100 sm:dark:hover:bg-gray-700 
             px-2 py-1 rounded-lg transition-colors"
          >
            <div className="w-8 h-8 rounded-full bg-green-200 flex items-center justify-center text-sm font-bold text-green-700">
              <img
                src={profiles?.image || profile}
                alt="Profile"
                className="w-7 h-7 rounded-full border-1 border-teal-600 object-cover"
              />
            </div>
          </div>

          {menuOpen && (
            <div
              className="absolute right-0 mt-3 w-52 bg-white dark:bg-[#1E2335]
    rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.15)] overflow-hidden 
    border border-gray-100 dark:border-white/10 
    animate-dropdown z-50"
            >
              <Link
                to="/settings/profile"
                onClick={() => setMenuOpen(false)}
                className="flex items-center gap-3 px-4 py-3 
      text-gray-700 dark:text-gray-200 
      hover:bg-gray-100 dark:hover:bg-white/10 transition"
              >
                <FaUser className="text-blue-500 text-lg" />
                <span className="text-sm font-medium">Profile</span>
              </Link>

              <Link
                to="/settings/profile"
                onClick={() => setMenuOpen(false)}
                className="flex items-center gap-3 px-4 py-3 
      text-gray-700 dark:text-gray-200 
      hover:bg-gray-100 dark:hover:bg-white/10 transition"
              >
                <FaCog className="text-sky-500 text-lg" />
                <span className="text-sm font-medium">Settings</span>
              </Link>

              <div className="border-t border-gray-200 dark:border-white/10"></div>

              <button
                onClick={() => {
                  setMenuOpen(false);
                  setShowLogoutPopup(true);
                }}
                className="flex items-center gap-3 w-full text-left px-4 py-3 
      text-red-600 dark:text-red-400 
      hover:bg-red-100 dark:hover:bg-red-700/30 transition"
              >
                <FaSignOutAlt className="text-red-500 dark:text-red-400 text-lg" />
                <span className="text-sm font-medium">Logout</span>
              </button>
            </div>
          )}
        </div>

        {/* Logout Popup remain same... */}
        {showLogoutPopup && (
          <div className="fixed inset-0 bg-black/60 z-[999] flex justify-center items-center">
            <div className="bg-[#0B1324] text-center p-8 rounded-2xl w-[90%] sm:w-[420px] shadow-xl">
              <h2 className="text-2xl font-semibold text-white mb-4">Logout Confirmation</h2>
              <p className="text-gray-300 text-sm mb-6 leading-relaxed">
                Are you sure you want to log out?<br />You will be signed out from the Super Admin panel.
              </p>
              <div className="flex justify-center gap-4">
                <button onClick={() => setShowLogoutPopup(false)} className="bg-white text-black px-6 py-3 rounded-lg w-32 font-medium hover:bg-gray-200 transition">Cancel</button>
                <button onClick={() => onErrorLogout()} className="bg-red-600 text-white px-6 py-3 rounded-lg w-32 font-medium hover:bg-red-700 transition">Logout</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;